<div class="form-group mx-5" *ngIf="by_document_type">
  <label>Select template by document type</label>
  <div class="input-group">
    <input type="text" ngDefaultControl name="document_type_search_term" [(ngModel)]="documentTypeSearchTerm" class="form-control" #documentTypeSearch (keyup)="fieldSearchDocumentType(documentTypeSearch.value)" placeholder="Search by document type or template" [disabled]="docTemplateItem" />
    <div class="input-group-append">
      <button type="button" class="btn btn-secondary" [disabled]="!docTemplateItem" (click)="clearSelectedDocTemplate()">
        <i class="fas fa-pencil-alt"></i>
      </button>
    </div>
  </div>
  <div class="mt-3">
    <div *ngFor="let documentType of documentTypes" class="pb-3">
      <a (click)="expandDocumentType(documentType)" href="javascript:void(0)">
        <i [class]="'fa ' + (documentType.expanded ? 'fa-minus-circle' : 'fa-plus-circle')"></i>
        &nbsp;
        {{ documentType.name }}
      </a>
      <div *ngIf="documentType.expanded">
        <div class="pl-2">{{ documentType.others == true ? 'Other Templates' : documentType === false ? 'Templates' : '' }}</div>
        <div *ngFor="let docTemplate of documentType.templates" class="pl-4">
          <a href="javascript:void(0)" (click)="selectTemplate(documentType, docTemplate)">{{ docTemplate.label }}</a>
          &nbsp;&nbsp;
          <a title="Open template" target="_blank" [href]="docTemplate.model == 'DocTemplate' ? '/doc_templates/' + docTemplate.id + '/edit?template=doctemplate' : '/doc_templates/new?document_template_id=' + docTemplate.id"><i class="fas fa-link"></i></a>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="form-group" *ngIf="list"></div>

<div class="form-group mx-5" *ngIf="autocomplete">
  <label>Select template directly</label>
  <div class="input-group">
    <input name="doc_template_search_term" ngDefaultControl [(ngModel)]="docTemplateSearchTerm" [appAutocomplete]="'/documents/autocomplete_template_name'" [data]="{ matter_id: matter_id }" (autocompleteSelect)="docTemplateSearchOnSelect($event)" [include_item]="true" placeholder="Search for document template" class="form-control" [disabled]="docTemplateItem" type="text" />
    <div class="input-group-append">
      <button type="button" class="btn btn-secondary" [disabled]="!docTemplateItem" (click)="clearSelectedDocTemplate()">
        <i class="fas fa-pencil-alt"></i>
      </button>
    </div>
  </div>
</div>
